import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AnyAaaaRecord } from 'node:dns';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IMessageDetails } from '../class/largereceipt';
import { CommonUtilService } from '../service/common-util.service';
import { LargereceiptService } from '../service/largereceipt.service';

@Injectable({
  providedIn: 'root'
})
export class MessagedetailsResolver implements Resolve<IMessageDetails> {
  constructor(private largeReceiptSvc: LargereceiptService,private router:Router
    ,private commonUtilService: CommonUtilService) {

    
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IMessageDetails> {
    this.commonUtilService.DisplayAndHideSideMenu('receipts/retrieve');
    let messageId = route.paramMap.get('messageId');
    //alert(messageId);
    if(messageId!=undefined)
      localStorage.setItem("MessageId",messageId);
    else if(messageId==undefined && localStorage.getItem("MessageId")!=undefined)
    {
        messageId=localStorage.getItem("MessageId");
    }
    
        if (messageId=='undefined') {
            
          //this.router.navigate(['/ErrorPage','Please enter valid Message id to get message details']);
          this.router.navigate(['/receipts/retrieve']);
            return of (null);
        }
        else{
          return this.largeReceiptSvc.getMessageDetailsFromServer(route.paramMap.get('messageId'))
          .pipe(
            catchError(error => {
              let errorDescription=error;
              this.router.navigate(['/errorpage',error]);
                return of(null);
            })
          );
        }
  }
}
